import {
  CLEAR_EDIT_RUNUP,
  GET_EDIT_RUNUP_REQUEST,
  CREATE_EDIT_RUNUP_REQUEST,
  UPDATE_EDIT_RUNUP_REQUEST,
  EDIT_RUNUP_TSUNAMI_REQUEST,
  EDIT_RUNUP_TSUNAMI_SEARCH_REQUEST,
  EDIT_RUNUP_REFERENCE_REQUEST,
  EDIT_RUNUP_REFERENCE_SEARCH_REQUEST,
  EDIT_RUNUP_AREA_REQUEST,
  EDIT_RUNUP_COUNTRY_REQUEST,
  EDIT_RUNUP_FIRST_MOTION_REQUEST,
  EDIT_RUNUP_LOCATION_REQUEST,
  EDIT_RUNUP_REGION_REQUEST,
  EDIT_RUNUP_MEASUREMENT_TYPE_REQUEST,
  EDIT_RUNUP_TSUNAMI_SORT,
  EDIT_RUNUP_REFERENCE_SORT,
  EDIT_RUNUP_OPEN_CONFIRMATION,
  EDIT_RUNUP_CANCEL_CONFIRMATION,
  EDIT_RUNUP_TSUNAMI_TOGGLE_COLUMN,
  EDIT_RUNUP_REFERENCE_TOGGLE_COLUMN,
} from './runupEditReducer';

export const getRunup = ({ id, history }) => ({ type: GET_EDIT_RUNUP_REQUEST, id, history });
export const clearRunup = () => ({ type: CLEAR_EDIT_RUNUP });
export const createRunup = ({
  data, formModel, location, goBack, history,
}) => ({
  type: CREATE_EDIT_RUNUP_REQUEST, data, formModel, location, goBack, history,
});
export const updateRunup = ({
  data, id, formModel, location, goBack, history,
}) => ({
  type: UPDATE_EDIT_RUNUP_REQUEST, data, id, formModel, location, goBack, history,
});
export const searchTsunamis = ({ queryParameters, history }) => ({
  type: EDIT_RUNUP_TSUNAMI_SEARCH_REQUEST,
  queryParameters,
  history,
});
export const getTsunami = ({ id, history }) => ({ type: EDIT_RUNUP_TSUNAMI_REQUEST, id, history });
export const searchReferences = ({ queryParameters, history }) => ({
  type: EDIT_RUNUP_REFERENCE_SEARCH_REQUEST,
  queryParameters,
  history,
});
export const getReferences = ({ id, history }) => ({ type: EDIT_RUNUP_REFERENCE_REQUEST, id, history });

export const getRegions = ({ history }) => ({ type: EDIT_RUNUP_REGION_REQUEST, history });
export const getCountries = ({ history }) => ({ type: EDIT_RUNUP_COUNTRY_REQUEST, history });
export const getAreas = ({ history }) => ({ type: EDIT_RUNUP_AREA_REQUEST, history });
export const getLocations = ({ history }) => ({ type: EDIT_RUNUP_LOCATION_REQUEST, history });
export const getFirstMotions = ({ history }) => ({ type: EDIT_RUNUP_FIRST_MOTION_REQUEST, history });
export const getMeasurementTypes = ({ history }) => ({ type: EDIT_RUNUP_MEASUREMENT_TYPE_REQUEST, history });
export const sortTsunamis = sort => ({ type: EDIT_RUNUP_TSUNAMI_SORT, sort });
export const sortReferences = sort => ({ type: EDIT_RUNUP_REFERENCE_SORT, sort });

export const openEditConfirmation = ({ formData }) => ({ type: EDIT_RUNUP_OPEN_CONFIRMATION, formData });
export const cancelEditConfirmation = () => ({ type: EDIT_RUNUP_CANCEL_CONFIRMATION });

export const toggleTsunamiColumns = visibleColumns => ({ type: EDIT_RUNUP_TSUNAMI_TOGGLE_COLUMN, visibleColumns });
export const toggleReferenceColumns = visibleColumns => ({ type: EDIT_RUNUP_REFERENCE_TOGGLE_COLUMN, visibleColumns });
